export const ECONOMIC_CALENDAR_STORAGE_KEYS = {
  CORE: "mt6_economic_calendar_core",
  FILTERS: "mt6_economic_calendar_filters",
  /** Hub-synced events + sequence metadata */
  SYNC: "mt6_vybe_economic_calendar",
  /** Per-month version hashes for hash-based sync */
  MONTH_VERSIONS: "mt6_vybe_economic_calendar_month_versions",
} as const;
